import type { RouteObject } from 'react-router';
import { CompanyCasesTab } from './cases/company-cases-tab';
import { CaseKpis } from './cases/home-kpis';
import { caseRoutes } from './cases/routes';
import { COMPANY_TAB_RENDERERS, COMPANY_TABS } from './companies/detail-page';
import { companyRoutes } from './companies/routes';
import { contactRoutes } from './contacts/routes';
import { contractRoutes } from './contracts/routes';
import { CRM_HOME_EXTRA } from './home/crm-home-page';
import { crmHomeRoute } from './home/routes';
import { CompanyWorkOrdersTab } from './work-orders/company-work-orders-tab';
import { workOrderRoutes } from './work-orders/routes';

// Register the Phase 3b additions with the Phase 3a extension points.
if (!COMPANY_TABS.some((t) => t.id === 'cases')) COMPANY_TABS.push({ id: 'cases', label: 'Cases' }, { id: 'work-orders', label: 'Work orders' });
COMPANY_TAB_RENDERERS.cases = (c) => <CompanyCasesTab companyId={c.id} />;
COMPANY_TAB_RENDERERS['work-orders'] = (c) => <CompanyWorkOrdersTab companyId={c.id} />;
if (CRM_HOME_EXTRA.length === 0) CRM_HOME_EXTRA.push(() => <CaseKpis />);

export const crmBranch: RouteObject = {
  path: 'crm',
  handle: { crumb: 'CRM' },
  children: [crmHomeRoute, ...companyRoutes, ...contactRoutes, ...contractRoutes, ...caseRoutes, ...workOrderRoutes],
};
